import type { UserProfile } from "@/domains/pm/types";
import { UserAvatar } from "@/components/ui/user-avatar";

interface AssigneeAvatarProps {
  user: UserProfile | null | undefined;
  size?: number;
  className?: string;
}

// Thin wrapper kept for back-compat with PM imports. New code should import
// UserAvatar directly from "@/components/ui/user-avatar".
export function AssigneeAvatar({ user, size = 24, className }: AssigneeAvatarProps) {
  return <UserAvatar user={user} size={size} className={className} />;
}
